import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export default function TxInput() {
  const navigate = useNavigate();
  const [signature, setSignature] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      const trimmed = signature.trim();
      if (!trimmed) return;

      setLoading(true);
      // Navigate immediately; TxDetailPage will handle fetching
      navigate('/tx/' + encodeURIComponent(trimmed));
      setSignature('');
      setLoading(false);
    },
    [signature, navigate]
  );

  return (
    <div className="space-y-3">
      <form onSubmit={handleSubmit} className="flex gap-2">
        <input
          type="text"
          value={signature}
          onChange={(e) => setSignature(e.target.value)}
          placeholder="Paste Solana transaction signature..."
          className="flex-1 rounded-lg border border-slate-700 bg-slate-900 px-4 py-2.5 text-sm text-slate-100 placeholder:text-slate-600 focus:border-violet-500 focus:outline-none focus:ring-1 focus:ring-violet-500/30 transition-colors"
        />
        <button
          type="submit"
          disabled={loading || !signature.trim()}
          className="rounded-lg bg-violet-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-violet-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
        >
          {loading ? (
            <>
              <Spinner />
              Loading…
            </>
          ) : (
            'Visualize'
          )}
        </button>
      </form>
      <p className="text-xs text-slate-500">
        Enter a base58 transaction signature from any Solana explorer.
      </p>
    </div>
  );
}

function Spinner() {
  return (
    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
        fill="none"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
